module.exports = __webpack_public_path__ + "img/business-03012025.d9e985f4.jpg";